import React, { memo } from 'react';
import cls from './DaysModeHeader.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { useInfiniteScrollNew } from 'shared/hooks/useInfinityScrollNew';
import { addMoreDays } from '../../../../../../helpers/getDays';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../../../../store/reducers/gantSlice/gantSlice';

export const DaysModeHeader = memo(() => {
    const dispatch = useDispatch();
    const { days } = useSelector((state) => state.gantReducer);
    const last = days[days.length - 1];

    const onLoadNextPartLast = () => {
        if (last) {
            const current = last.dataDays;
            const newDays = addMoreDays(current, 'last');
            dispatch(gantActions.setDays([...days, ...newDays]));
        }
    };

    const lastElementRef = useInfiniteScrollNew(onLoadNextPartLast);

    if (days.length === 0) return null;

    const lastDay = last.dataDays;

    const triggerLastDays = moment(lastDay, 'MM.YYYY').subtract(3, 'months').format('MM.YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    return (
        <div className={classNames(cls.DaysModeHeader)}>
            {days.map((month) => (
                <div className={classNames(cls.monthWrapper)} key={month.title}>
                    <div className={classNames(cls.month)}>{month.title}</div>
                    <div className={classNames(cls.days)}>
                        {month.days.map((day) => (
                            <div
                                data-date={moment(day.date, 'DD.MM.YYYY').format()}
                                key={day.day}
                                data-date-now={day.date === nowDate}
                                className={classNames(cls.day, {
                                    [cls.weekend]: day.isWeekend,
                                    [cls.nowDate]: day.date === nowDate,
                                })}
                            >
                                {day.day}
                            </div>
                        ))}
                        {month.dataDays === triggerLastDays && <div ref={lastElementRef}></div>}
                    </div>
                </div>
            ))}
        </div>
    );
});
